import {
  FunctionComponent,
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';
import {
  EmbedHelperImperativeRef,
  EmbedMarketingHandler,
} from '../components/EmbedHandler/index';

type Controls = EmbedHelperImperativeRef | null;

export interface EmbedControlContextData {
  controls: Controls;
  setControls: (controls: Controls) => void;
}

const EmbedControlContext = createContext<EmbedControlContextData>(
  {} as EmbedControlContextData,
);

export const EmbedControlProvider: FunctionComponent<
  PropsWithChildren<unknown>
> = ({ children }) => {
  const [controls, setControls] = useState<Controls>(null);

  return (
    <EmbedControlContext.Provider
      value={{
        controls,
        setControls,
      }}
    >
      {children}
    </EmbedControlContext.Provider>
  );
};

export const useEmbedControl = () => useContext(EmbedControlContext).controls;

export const EmbedControlWrapper: FunctionComponent = () => {
  const { setControls } = useContext(EmbedControlContext);

  return <EmbedMarketingHandler ref={setControls} />;
};
